export default {"src":"/_next/static/media/pattern.f004cd94.svg","height":325,"width":323,"blurWidth":0,"blurHeight":0};